import { X } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

/**
 * Right-side slide-over used by appointments workspace.
 *
 * @param {{
 *   open: boolean
 *   onClose: () => void
 *   title: string
 *   subtitle?: string
 *   children: import('react').ReactNode
 *   footer?: import('react').ReactNode
 *   widthClassName?: string
 * }} props
 */
export function ScheduleSideDrawer({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  widthClassName = 'w-full max-w-[28rem]',
}) {
  if (!open) {
    return null
  }

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <button
        type="button"
        className="absolute inset-0 bg-foreground/35 backdrop-blur-[1px]"
        aria-label="Close panel"
        onClick={onClose}
      />
      <aside
        className={cn(
          'relative z-10 flex h-full flex-col border-l border-border/70 bg-card shadow-luxury-lg',
          'animate-in slide-in-from-right duration-200',
          widthClassName,
        )}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="flex items-start justify-between gap-3 border-b border-border/60 px-5 py-4">
          <div className="min-w-0">
            <h2 className="text-base font-semibold tracking-tight text-foreground">{title}</h2>
            {subtitle ? (
              <p className="mt-0.5 text-xs text-muted-foreground">{subtitle}</p>
            ) : null}
          </div>
          <Button type="button" variant="ghost" size="icon" onClick={onClose} aria-label="Close">
            <X className="h-4 w-4" />
          </Button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">{children}</div>

        {footer ? (
          <div className="border-t border-border/60 bg-muted/20 px-5 py-4">{footer}</div>
        ) : null}
      </aside>
    </div>
  )
}
